<template>
    <div>
        <b-form enctype="multipart/form-data">
            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Setor"
                    label-for="sector"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-select id="sector"
                            v-model="selectedItem.stockLocationId"
                            :plain="true"
                            :options="selectSectorDDL"
                            :class="sectorField"
                            >
                        </b-form-select>
                    </b-form-group>          
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Inicial: "
                    label-for="range"
                    :label-cols="3"
                    :horizontal="true">
                        <b-row>
                            <b-col><b-form-input v-model="selectedItem.labelStart" id="labelStart" type="number"  :class="labelStartField" ></b-form-input></b-col>
                            <b-col lg="2">Final: </b-col>
                            <b-col><b-form-input v-model="selectedItem.labelEnd" id="labelEnd" type="number" :class="labelEndField"></b-form-input></b-col>
                        </b-row>                        
                    </b-form-group>          
                </b-col>
            </b-row>

        </b-form>
    
        <div slot="footer" class="text-right">
            <b-button variant="github" class="mr-1 btn-brand" @click="addRange()"><i class="fa fa-check"></i><span>Adicionar Faixa</span></b-button>
        </div>

    </div>    
</template>


<script>
import Vue from 'vue'
import axios from "axios";

//import ProductSelectComponent from '../stock/ProductSelectComponent'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
success: 'success',
error: 'error',
info: 'info',
warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
return miniToastr[type](message, title, timeout, cb)
}

const options = {
success: toast,
error: toast,
info: toast,
warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'inventorySectorLabelComponent',
    props: {
        inventory: Object,
        item: Object,
        companyId: Number
    },
    components: {
    },
    data: () => {
        return {
            labelStartField: '',
            labelEndField: '',
            sectorField: '',

            errorMessage: "",
            notes: "",
            sectorDDL: []
        }
    },
    computed: {
        selectSectorDDL: function() {
            var list = [...this.sectorDDL]
            list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
            return list
        },
       currentInventory() {
            return this.inventory
       },
       selectedItem() {
            return this.item
       }
    },
    methods: {

        async saveItem() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            var postData = this.selectedItem
            postData["inventoryId"] = Number(this.currentInventory.id)
            postData["uid"] = currentUser.id
            postData["sid"] = currentUser.sid
            
            var url = this.$store.state.ws_url + "/stock/location/label"
            
            await axios.post(
                url,
                postData
            ).then(function(resp) {
                s.$emit('response', {code: 1, obj: postData, message: 'Setor incluído com sucesso'});                
            }).catch(function(error) {
                console.log(error)
                var msg = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Faixa já incluída.'
                s.$emit('response', {code: -1, message: msg})
            })
            
        },

        addRange() {
            var containsError = false
            if(this.selectedItem.labelStart == null || this.selectedItem.labelStart <= 0) {
                this.labelStartField = 'is-invalid'
                containsError = true
            }
            else {
                this.labelStartField = ''
            }

            if(this.selectedItem.labelEnd == null || this.selectedItem.labelEnd <= 0) {
                this.labelEndField = 'is-invalid'
                containsError = true
            }
            else {
                this.labelEndField = ''
            }

            if(this.selectedItem.stockLocationId == null || this.selectedItem.stockLocationId <= 0) {
                this.sectorField = 'is-invalid'
                containsError = true
            }
            else {
                this.sectorField = ''
            }
                        
            if(!containsError) {
                this.saveItem();
            }

        },


        async getSector() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/stock/location/ddl?companyId=" + s.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                
            ).then(function(resp) {
                s.sectorDDL = resp.data.obj;
            }).catch(function (error) {
                console.log(error);
            });
        },

        refreshData() {
            
        }
    },
    mounted: function() {
        this.getSector()
    }

}

</script>